/**
 * AdminReduxStatePanel React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import connect from "react-redux/es/connect/connect";

// Material UI
import { withStyles } from '@material-ui/core/styles';

// Material UI components
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import Button from "@material-ui/core/Button/Button";

// icons
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CallToActionIcon from "@material-ui/icons/CallToAction";


/**
 * Panel for admin page to show current redux state
 *
 * @author Jens Gruschel
 */
class AdminReduxStatePanel extends React.Component {

    logReduxState() {
        console.log("state:", this.props.reduxState);
    }
    
    render() {

        const { classes } = this.props;

        return <ExpansionPanel defaultExpanded={true}>

            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                <Typography>Redux-Status</Typography>
            </ExpansionPanelSummary>

            <ExpansionPanelDetails>
                <div className={classes.detailsPage}>
                    <div>
                        <Button
                            className={classes.button} 
                            onClick={() => {this.logReduxState();}}
                        ><CallToActionIcon className={classes.leftIcon}/>log to console</Button>
                    </div>

                    <textarea value={JSON.stringify(this.props.reduxState, null, 4)}
                        style={{width: "100%", height: "500px", fontFamily: "monospace"}} readOnly={true}
                    />
                </div>
            </ExpansionPanelDetails>

        </ExpansionPanel>;
    }
}

const styles = theme => ({
    detailsPage: {
        width: "100%"
    },
    button: {
        margin: theme.spacing.unit
    },
    leftIcon: {
        marginRight: theme.spacing.unit
    }
});

const mapStateToProps = state => {
    return {
        reduxState: state
    };
};

export default connect(mapStateToProps)(withStyles(styles)(AdminReduxStatePanel));